// The text primitives the rooms and Statistics share, each ported once from SuiteModel (and SuiteStyle's tagger seam):
// Unicode scalars (`scalars.ts`), `ProseWords`, `Sentences` (the one splitter: Readability, Sentence lengths, Shape, the
// style linter, continuity, story times, the glossary and History's TextDiff all use it), NSRegularExpression patterns
// (`icu`), `QuoteMarks`, TextCleanup's quotation reading (`quotations`, `curled`, `lines`), `DialogueBalance`,
// `Readability` with `SentenceLengths`, `WordFrequency`, and what the Mac asks of `NLTagger` (`tagger.ts`).
export * from './scalars.ts';
export * from './proseWords.ts';
export * from './sentences.ts';
export * from './icuRegex.ts';
export * from './quoteMarks.ts';
export * from './quotations.ts';
export * from './dialogueBalance.ts';
export * from './readability.ts';
export * from './wordFrequency.ts';
export * from './tagger.ts';
